export default function Logo({ size = 36, onClick }) {
  return (
    <span
      onClick={onClick}
      style={{
        fontStyle: "italic",
        fontWeight: 700,
        fontSize: size,
        cursor: onClick ? "pointer" : "default",
        userSelect: "none",
        display: "inline-flex",
        alignItems: "baseline",
        position:'relative',
        top:'-2px'
      }}
    >
      <span style={{ color: "#000" }}>Tall</span>
      <span style={{ color: "#3B00FF", marginLeft: 2 }}>
        Slide
      </span>
    </span>
  );
}
